import apiClient from '@/plugins/axios'

export default {
  getTipoContatos() {
    return apiClient.get('tipocontato')
  },

  getTipoContato(id) {
    return apiClient.get(`tipocontato/${id}`)
  },

  postTipoContato(tipocontato) {
    return apiClient.post(`tipocontato`, { tipocontato })

  },

  putTipoContato(id, tipocontato) {
    return apiClient.put(`tipocontato/${id}`, { tipocontato })

  },

  deleteTipoContato(id) {
    return apiClient.delete(`tipocontato/${id}`)

  },

  getDropDown() {
    return apiClient.get(`tipocontato/dropdown`)

  }

}


// WEBPACK FOOTER //
// ./src/views/TipoContato/_services/TipoContatoService.js